export enum TestType {
  RECURRING = 'automated',
  MANUAL_SEQUENCE = 'manual-internal',
  MANUAL_EXTERNAL = 'manual-external',
}

export enum TestStatus {
  Active = 'active',
  Paused = 'paused',
  Completed = 'completed',
  Draft = 'draft',
  Stopped = 'stopped',
}

export enum TestTemplateAction {
  Pause = 'pause',
  Resume = 'resume',
  ReRun = 're-run',
  Delete = 'delete',
  PauseCycle = 'pause-cycle',
  ResumeCycle = 'resume-cycle',
}

export enum SeedTestPauseReason {
  EmailAccountDisconnected = 1,
  TestStepDataDeleted = 2,
  TestStopped = 3,
  ManuallyPausedByUser = 4,
}

export enum SeedTestTemplatePauseReason {
  EmailAccountDisconnected = 1,
  TestStepDataDeleted = 2,
  ManuallyPausedByUser = 3,
  ScheduleEnded = 4,
  TestQuotaExceeded = 5,
}

export const SeedTestPauseReasonMessages = {
  [SeedTestPauseReason.EmailAccountDisconnected]:
    'test_template_email_account_disconnected',
  [SeedTestPauseReason.TestStepDataDeleted]:
    'test_template_test_step_data_deleted',
  [SeedTestPauseReason.TestStopped]: 'test_template_test_stopped',
};

export const SeedTestTemplatePauseReasonMessages = {
  [SeedTestTemplatePauseReason.EmailAccountDisconnected]:
    'test_template_email_account_disconnected',
  [SeedTestTemplatePauseReason.TestStepDataDeleted]:
    'test_template_test_step_data_deleted',
  [SeedTestTemplatePauseReason.ManuallyPausedByUser]:
    'test_template_manually_paused_by_user',
  [SeedTestTemplatePauseReason.ScheduleEnded]: 'test_template_schedule_ended',
  [SeedTestTemplatePauseReason.TestQuotaExceeded]:
    'test_template_test_quota_exceeded',
};

export enum SeedTestSenderEmailAccountPauseReason {
  EmailAccountDisconnectDueToPlacementRate = 1,
  EmailAccountDisconnected = 2,
  EmailAccountDeleted = 3,
  ManuallyPausedByUser = 4,
}

export const SeedTestSenderEmailAccountPauseReasonMessages = {
  [SeedTestSenderEmailAccountPauseReason.EmailAccountDisconnectDueToPlacementRate]:
    'email_account_disconnect_due_to_placement_rate',
  [SeedTestSenderEmailAccountPauseReason.EmailAccountDisconnected]:
    'sender_email_account_disconnected',
  [SeedTestSenderEmailAccountPauseReason.EmailAccountDeleted]:
    'sender_email_account_deleted',
};

export const SeedTestStoppedReasonMessages = {
  [SeedTestPauseReason.EmailAccountDisconnected]:
    'all_email_account_disconnected',
  [SeedTestPauseReason.TestStepDataDeleted]: 'sequence_or_steps_deleted',
  [SeedTestPauseReason.TestStopped]: 'test_template_test_stopped',
  [SeedTestPauseReason.ManuallyPausedByUser]:
    'test_template_manually_stopped_by_user',
};

export enum TestConfig {
  MaxTestNameLength = 100,
}

export enum InsightKeys {
  SpamScore = 'spamScore',
  EmailAuthentication = 'emailAuthentication',
  LinksAndAttachments = 'linksAndAttachments',
  SpamTriggeringWords = 'spamTriggering',
  SubjectLine = 'subjectLine',
  Personalization = 'personalization',
  PlainTextPercentage = 'planTextPercentage',
  EmailCopy = 'emailCopy',
}

export enum SpamAssassinScoreReportFilter {
  All = 'all',
  Positive = 'positive',
  Negative = 'negative',
}

export enum EmailReputationStatus {
  Valid = 'valid',
  Invalid = 'invalid',
  Mixed = 'mixed',
}


export enum TimeUnitType {
  Day = 'day',
  Week = 'week',
  Month = 'month',
}

export enum MonthlyRecurringType {
  Day = 'day',
  Week = 'week',
}

export enum EndRepeatOptions {
  Never = 'never',
  On = 'on',
}

export enum EmailDeliveryMode {
  OneByOne = 'one-by-one',
  AllAtOnce = 'once',
}